import React from "react";

const EyeIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 35 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24.25 16a7 7 0 1 1-14 0 7 7 0 0 1 14 0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.988 16.189a1.5 1.5 0 0 1-2.976-.375L1.5 16a136 136 0 0 1-1.488-.188v-.007l.003-.013.005-.042.022-.142q.027-.181.089-.499c.082-.42.216-1.012.421-1.717.41-1.404 1.115-3.29 2.301-5.187C5.257 4.358 9.633.5 17.25.5s11.993 3.858 14.397 7.705c1.186 1.897 1.891 3.783 2.301 5.187.206.705.339 1.296.422 1.717a14 14 0 0 1 .11.641l.006.042.002.014v.006c0 .001 0 .002-1.488.188l1.489-.186a1.5 1.5 0 0 1-2.977.373v-.001l-.003-.017-.014-.092a11 11 0 0 0-.07-.39c-.067-.344-.18-.847-.357-1.455-.356-1.22-.963-2.835-1.965-4.437C27.133 6.64 23.633 3.5 17.25 3.5S7.368 6.64 5.397 9.795c-1.001 1.602-1.609 3.217-1.965 4.437a17 17 0 0 0-.357 1.455 11 11 0 0 0-.084.482l-.003.018z"
    />
  </svg>
);

export default EyeIcon;
